module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-candy@3x-8ce7e21225b84f5a14101134a80a01d9.png";